var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('image',{directives:[{name:"show",rawName:"v-show",value:(!_vm.failed),expression:"!failed"}],attrs:{"href":_vm.href},on:{"error":_vm.onError}}),_vm._v(" "),_c('svg-badge',{attrs:{"x":_vm.lx,"y":_vm.ly,"variant":"primary","scale":_vm.scale}},[_vm._v("$"+_vm._s(_vm.annotation.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }